import { useQuery } from "@tanstack/react-query";

import { fetchNangoProjects } from "@shared/api";

import { useOrgAssertDefined } from "../useOrgAssertDefined";
import { usePrimaryNangoTicketingInstance } from "../usePrimaryNangoTicketingInstance";

export const useNangoIssueTypeProjects = () => {
  const org = useOrgAssertDefined();
  const { data: primaryNangoTicketingInstance } =
    usePrimaryNangoTicketingInstance();

  return useQuery({
    queryKey: ["NangoProjects", { org, primaryNangoTicketingInstance }],
    queryFn: () =>
      fetchNangoProjects(
        org.id,
        primaryNangoTicketingInstance!.id,
        primaryNangoTicketingInstance!.subdomain,
        primaryNangoTicketingInstance!.issue_type_id
      ),
    enabled:
      !!primaryNangoTicketingInstance &&
      !primaryNangoTicketingInstance.is_auth_revoked &&
      !!primaryNangoTicketingInstance.subdomain &&
      !!primaryNangoTicketingInstance.issue_type_id,
  });
};
